import { createFileRoute } from '@tanstack/react-router'

import { ChatThread, Composer } from '@/components/shared'
import { QUICK_REPLIES, SPECIALIST, THREAD } from '@/mocks/fotograf/chat'

export const Route = createFileRoute('/fotograf/chat')({
  head: () => ({ meta: [{ title: 'Chat s Bárou · Aplikace Bitez' }] }),
  component: FotografChat,
})

/**
 * The photographer's one conversation — with the správce, never with the client
 * (open-items B12). The client's channel to him is the brief; his to them is
 * her.
 *
 * One thread, so it gets no tab: a fifth tab for a single conversation would
 * cost him a permanent seat in the bar for something he opens twice a week. It
 * hangs off his overview and off the shoot he is working on, which are the two
 * places the question ever comes up.
 *
 * Same island, same bubbles, same composer as everyone else — only the quick
 * replies are his: a heads-up, a question, a promise.
 */
function FotografChat() {
  return (
    <div className="flex min-h-full flex-col px-4">
      <div className="sticky top-2 z-10 flex justify-center pt-2">
        <div className="flex items-center gap-2 rounded-full bg-white py-1.5 pr-3.5 pl-1.5 shadow-lg ring-1 ring-ink/5">
          <span className="relative shrink-0">
            <img
              src={SPECIALIST.avatar}
              alt=""
              width={80}
              height={80}
              className="size-7 rounded-full object-cover"
            />
            <span
              aria-label="Online"
              className="absolute right-0 bottom-0 size-2 rounded-full bg-success ring-1 ring-white"
            />
          </span>
          <span className="min-w-0">
            <span className="font-display block text-sm leading-none uppercase">
              {SPECIALIST.name}
            </span>
            <span className="mt-0.5 block text-[9px] leading-none font-semibold text-ink/45">
              {SPECIALIST.role}
            </span>
          </span>
        </div>
      </div>

      <ChatThread entries={THREAD} avatar={SPECIALIST.avatar} />

      <Composer suggestions={QUICK_REPLIES} placeholder="Napište Báře…" />
    </div>
  )
}
